import { request } from 'utils/requests';

/**
 * Busca informações de um processo no DataJud
 * @param {string} numeroProcesso - Número do processo (com ou sem pontuação)
 * @returns {Promise} Dados do processo do DataJud
 */
export const searchProcessDataJud = async (numeroProcesso) => {
  const { data } = await request.get(`/datajud/processo/${numeroProcesso}`);
  return data;
};

/**
 * Busca movimentações de um processo no DataJud
 * @param {string} numeroProcesso - Número do processo
 * @param {object} params - Parâmetros opcionais { dataInicio, dataFim }
 * @returns {Promise} Movimentações do processo
 */
export const searchMovementsDataJud = async (numeroProcesso, params = {}) => {
  const { data } = await request.get(`/datajud/movimentacoes/${numeroProcesso}`, { params });
  return data;
};

/**
 * Enriquece um processo existente com dados do DataJud
 * @param {string} processoId - ID do processo local
 * @param {string} numeroProcesso - Número do processo
 * @returns {Promise} Dados enriquecidos
 */
export const enrichProcessDataJud = async (processoId, numeroProcesso) => {
  const { data } = await request.post(`/datajud/enriquecer/${processoId}`, { numeroProcesso });
  return data;
};
